import React from "react";

// Varied heights mimic the masonry layout's natural variation. Repeating the
// pattern is fine because skeletons disappear once real cards land.
const IMAGE_HEIGHTS = [320, 240, 380, 280, 360, 220, 300, 340];

const SkeletonCard = ({ height, delay }) => (
    <article
        className="card-enter break-inside-avoid mb-5 bg-white rounded-2xl shadow-brand overflow-hidden"
        style={{ animationDelay: `${delay}ms` }}
    >
        <div
            className="w-full bg-brand-panel animate-pulse"
            style={{ height: `${height}px` }}
        />
        <div className="px-5 pt-5">
            <div className="h-4 bg-brand-panel rounded animate-pulse" />
            <div className="mt-2 h-4 bg-brand-panel rounded animate-pulse w-2/3" />
            <div className="mt-3 h-3 bg-brand-panel/70 rounded animate-pulse w-5/6" />
        </div>
        <div className="px-5 pb-5 pt-5">
            <div className="flex gap-2">
                {[0, 1, 2, 3].map((i) => (
                    <div key={i} className="h-12 w-12 rounded-full bg-brand-panel animate-pulse" />
                ))}
            </div>
            <div className="mt-3 flex items-center justify-between">
                <div className="h-3 w-20 bg-brand-panel/70 rounded animate-pulse" />
                <div className="h-3 w-12 bg-brand-panel/70 rounded animate-pulse" />
            </div>
        </div>
    </article>
);

const FeedSkeleton = ({ count = 8 }) => {
    return (
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-8 sm:py-10 columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-5">
            {Array.from({ length: count }).map((_, i) => (
                <SkeletonCard
                    key={i}
                    height={IMAGE_HEIGHTS[i % IMAGE_HEIGHTS.length]}
                    delay={Math.min(i, 7) * 50}
                />
            ))}
        </div>
    );
};

export default FeedSkeleton;
